import apisauce from 'apisauce';
import { processApiResponse } from './AtApi';

export const create = (cancelToken) => {
  const KEY = process.env.REACT_APP_TIMETABLE_API_KEY || process.env.REACT_APP_AT_API_KEY;
  const baseURL = process.env.REACT_APP_TIMETABLE_API_URL || process.env.REACT_APP_AT_API_URL || 'https://test-api.at.govt.nz/';
  const getUrl = () => baseURL;
  const getKey = () => KEY;
  const api = apisauce.create({ baseURL, cancelToken, timeout: 60000 });

  api.addRequestTransform((request) => {
    request.headers['Ocp-Apim-Subscription-Key'] = KEY;
  });

  // New Timetable routes
  const getTimetableRoutes = ({ text, routeTypes }) => api
    .get('timetable/legacy/routes', { search_string: text, route_types: routeTypes })
    .then(processApiResponse);
  const getStopsByShapeId = ({ shapeIds }) => api
    .get('timetable/legacy/stops', { shape_ids: shapeIds })
    .then(processApiResponse);
  const getTimetableSchedule = ({ shapeId, stopCode, routeShortName }) => api
    .get('timetable/legacy/times', {
      shape_id: shapeId,
      stop_code: stopCode,
      route_short_name: routeShortName,
    })
    .then(processApiResponse);

  return {
    getUrl,
    getKey,
    getTimetableRoutes,
    getStopsByShapeId,
    getTimetableSchedule,
  };
};

const instance = create();
const getInstance = () => instance;

export default {
  create,
  getInstance,
};
